var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsPremierepro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 44.85,
    viewBox: "0 0 46 44.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "skills_premierepro",
    transform: "translate(-1485 -774)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M8.146,0H37.854A8.139,8.139,0,0,1,46,8.146V36.7a8.139,8.139,0,0,1-8.146,8.146H8.146A8.139,8.139,0,0,1,0,36.7V8.146A8.139,8.139,0,0,1,8.146,0Z",
    transform: "translate(1485 774)",
    fill: "#5637fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M57,79.368V59.626c0-.134.057-.211.192-.211.326,0,.632,0,1.073-.019.46-.019.939-.019,1.457-.038s1.073-.019,1.667-.038,1.169-.019,1.744-.019a11.27,11.27,0,0,1,3.948.594,6.844,6.844,0,0,1,2.568,1.572,6.1,6.1,0,0,1,1.4,2.185,7.336,7.336,0,0,1,.441,2.492,6.852,6.852,0,0,1-1.15,4.083,6.567,6.567,0,0,1-3.086,2.338,12.422,12.422,0,0,1-4.312.652c-.46,0-.767,0-.958-.019s-.46-.019-.824-.019v6.152a.238.238,0,0,1-.211.268H57.23c-.153,0-.23-.077-.23-.249Zm4.178-16.234v6.44c.268.019.518.038.748.038h1.016a7.159,7.159,0,0,0,2.2-.345,3.3,3.3,0,0,0,1.572-1.016,2.962,2.962,0,0,0,.594-1.974,3.155,3.155,0,0,0-.441-1.706,2.779,2.779,0,0,0-1.342-1.092,5.624,5.624,0,0,0-2.262-.383c-.5,0-.939,0-1.3.019a4.388,4.388,0,0,0-.786.019Z",
    transform: "translate(1438.925 726.066)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M146.176,83.816h3.354a.432.432,0,0,1,.4.307,1.946,1.946,0,0,1,.115.479c.038.192.077.4.1.594.019.211.038.441.038.69a7.133,7.133,0,0,1,2.051-1.648,5.94,5.94,0,0,1,2.913-.747.238.238,0,0,1,.268.211v3.814c0,.153-.1.211-.307.211a8.334,8.334,0,0,0-2.07.192,7.887,7.887,0,0,0-1.61.518,2.98,2.98,0,0,0-.978.709v9.775c0,.192-.077.268-.249.268h-3.776a.265.265,0,0,1-.307-.23V88.262c0-.46,0-.939-.019-1.437s-.019-1-.038-1.5c0-.441-.038-.862-.077-1.3a.177.177,0,0,1,.134-.211c0-.019.038-.019.058,0Z",
    transform: "translate(1366.999 706.514)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsPremierepro);
export default __webpack_public_path__ + "static/media/skills_premierepro.d238ca1fd2b422ff091d2a49811d72b6.svg";
export { ForwardRef as ReactComponent };